import React, {Fragment} from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import ValidationItem from "../ValidationItem";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    comment?: string
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 04/07/2022
 * @last_update 04/07/2022
 **/
class Commentary extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <Fragment>
                {
                    this.props.comment ? (
                        <ValidationItem label={getTranslation("steps.validation.labels.comment")}>
                            {this.props.comment}
                        </ValidationItem>
                    ) : ""
                }
            </Fragment>

        );

    };

}

export default withTranslation()(Commentary);
